import QuestionTypeBloodType from ".";

export default function QuestionTypeBloodTypeExamples() {
  function onChange(answer: any) {
    console.log("onChange()", answer);
  }

  return <QuestionTypeBloodType onChange={onChange} />;
}
